import React from 'react'
import Link from 'gatsby-link'

import styles from './News.module.css'

function Badge({ children, title }) {
  return (
    <div className={styles.bar}>
      <div className={styles.badge}><span>{title}</span></div>
      <div className={styles.children}>{children}</div>
      <div className={styles.chevron} />
    </div>
  )
}

function Inline({ children }) {
  return (
    <div className={styles.inline}>
      {children}
      <div className={styles.chevron} />
    </div>
  )
}

const News = ({ style, to, ...props }) => (
  <a className={styles.container} href={to}>
    {style === 'badge' ? <Badge {...props} /> : <Inline {...props} />}
  </a>
)

export default News



// WEBPACK FOOTER //
// ./src/components/News.js